import { Button, Group, Stack, Text, ThemeIcon } from "@mantine/core"

const StepNumber: React.FC<{ step: number }> = ({ step }) => {
    return (
        <ThemeIcon>
            <Text size="md" fw={700} c="white">
                {step}
            </Text>
        </ThemeIcon>
    )
}

const Step: React.FC<{ step: number; body: React.ReactNode }> = ({ step, body }) => {
    return (
        <Group gap={"lg"} wrap="nowrap">
            <StepNumber step={step} />
            <Stack>
                {body}
            </Stack>
        </Group>
    )
}

export const TeamsStep: React.FC = () => {

    return (
        <Stack w={700}>
            <Text>
                Microsoft Teams will play a large role during your time at College - you can contact teachers, upload assignments, and more.
            </Text>
            <Text>
                Don't worry if you're not familiar with Teams yet. All you need to know for now is how to find your induction work. Read through these steps, then click the Open Teams button.
            </Text>
            <Stack ml={'xl'} w={600} mt="lg">
                <Step step={1} body={<Text size="sm">Click on the Teams tab in the left sidebar to open your Teams list.</Text>} />
                <Step step={2} body={<Text size="sm">Look for the Induction Work team in your Teams list. You may have to expand the Classes section if it is collapsed.</Text>} />
                <Step step={3} body={<Text size="sm">Select a subject from the channels list in the bottom left. You may have to expand the subject list if it is collapsed.</Text>} />
                <Step step={4} body={<Text size="sm">Click on the Files tab at the top.</Text>} />
                <Step step={5} body={<Text size="sm">Return here when you are done.</Text>} />
            </Stack>
            <Stack mt="xl" align="center">
                <Button className="w-fit!" component="a" href="https://teams.microsoft.com/" target="_blank" rel="noopener noreferrer">
                    Open Teams
                </Button>
            </Stack>
        </Stack>
    )
}